<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h4 style="color: white;" *ngIf="estadoFuente=='2'">Activar Fuente</h4>
      <h4 style="color: white;" *ngIf="estadoFuente=='1'">Inactivar Fuente</h4>
    </div>
    <div class="card-body">
      <form>
        <div class="container-fluid">
          <div class="row">
            <div class="col-4">
              <div><label><b>Código</b></label></div>
              <div><input class="form-control" type="text" name="codigo" [(ngModel)]="fuenteActivacion.codEnti" disabled></div>
            </div>
            <div class="col-8">
              <div><label><b>Razón Social</b></label></div>
              <div><input class="form-control" type="text" name="nombreEntidad" [(ngModel)]="fuenteActivacion.nombEntidad" disabled></div>
            </div>
          </div>
        </div>
        <br>
        <div class="container-fluid">
          <div class="row">
            <div><label><b>Observación</b></label></div>
            <div><textarea class="form-control" type="text" name="observacion" [(ngModel)]="nuevaActivaFuente.observacion" rows="4" cols="12" required></textarea></div>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer">
      <button type="button" class="btn btn-secondary" (click)="regresarFuentes()">Cancelar</button>
      <button type="submit" class="btn btn-primary" (click)="guardarActivacion()" [disabled]="!btnguardar">Guardar</button>
    </div>
  </div>
</body>
